import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'post-vechile-status',
  templateUrl: 'post-vechile-status.html'
})
export class PostVechileStatusComponent {
  @Input() mode: string;
  @Input()
  set vechileStatusInput(val: any) {
    this.vechileStatusVal = val;
    this.vechileStatus = val ? JSON.parse(JSON.stringify(val)) : {};
  }
  @Output() change: EventEmitter<any> = new EventEmitter();
  text: string;
  vechileStatusVal: any;
  vechileStatus = {};
  constructor() {
  }

  statusChange() {
    if (this.mode === 'EDIT') {
      this.change.emit(this.vechileStatus);
    }
  }

  ngAfterViewInit(): void {

  }

  changeTxt(event, attributeName) {
    this.vechileStatus[attributeName] = event.value;
    this.statusChange();
  }

}



// WEBPACK FOOTER //
// ./src/components/post-vechile-status/post-vechile-status.ts